import * as React from "react";

function SvgIcSuccessForm(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm15.65-2.24a1 1 0 00-1.3-1.52l-6.298 5.398-2.345-2.345a1 1 0 00-1.414 1.414l3 3a1 1 0 001.358.052l7-6z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcSuccessForm;
